import { DistrictDto, FieldOptionInterface, ProviderDto, EngagementStatusDto } from '@families-link/shared';
import { FilterValuesStrings, FilterValuesArrays } from '../pages/dashboard.page';

export const inverseTransformFilterValues = (
	filters: FilterValuesStrings,
	currentDistrict?: DistrictDto
): FilterValuesArrays => ({
	districts: filters.districtIds
		? filters.districtIds
				.split(',')
				.filter(Boolean)
				.map((id) => ({ _id: id } as DistrictDto))
		: [],
	engagementType: filters.engagementTypes ? filters.engagementTypes.split(',').filter(Boolean) : [],
	duration: filters.duration
		? filters.duration.map((d) => (d ? new Date(d) : null)).filter((d): d is Date => d !== null)
		: [],
	schools: filters.schoolIds
		? filters.schoolIds
				.split(',')
				.filter(Boolean)
				.map((id) => ({ _id: id } as FieldOptionInterface))
		: [],
	programs: filters.programIds
		? filters.programIds
				.split(',')
				.filter(Boolean)
				.map((id) => ({ _id: id } as FieldOptionInterface))
		: [],
	services: filters.serviceIds
		? filters.serviceIds
				.split(',')
				.filter(Boolean)
				.map((id) => ({ _id: id } as FieldOptionInterface))
		: [],
	providers: filters.providerIds
		? filters.providerIds
				.split(',')
				.filter(Boolean)
				.map((id) => ({ _id: id } as ProviderDto))
		: [],
	languages: filters.languages ? filters.languages.split(',').filter(Boolean) : [],
	engagementStatus: filters.engagementStatuses
		? filters.engagementStatuses
				.split(',')
				.filter(Boolean)
				.map((id) => ({ _id: id } as EngagementStatusDto))
		: [],
	//linkType: filters.linkType ?? 'family-link',
});
